export const LOCAL_STORAGE_NAMESPACE = 'ohz';
export const LOCAL_STORAGE_PREFIX = LOCAL_STORAGE_NAMESPACE + ':';
export const LOCAL_STORAGE_KEYS = {
  session_id: 'session_id',
  session_data: 'data',
};
